import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'

export const modelAuditSchema = new schema.Entity(
    'model_audits',
    {},
    {
        idAttribute: 'id',
    }
)


export const modelAudit_getModelAudits_Api = {
    name: 'modelAudit_getModelAudits_Api',
    backend: `Route::get('audits/{type}/{id}/model-audits', 'ModelAuditController@getAuditsByCourseOwner');`,
    root: API_ROOT_URL,
    path: '/audits/:type/:id/model-audits',
    method: 'GET',
    paramsFields: ['page', 'group_type'],
    schema: modelAuditSchema,
    transform: createListTransform(modelAuditSchema),
}